import React, { useState, useEffect } from "react";
import {
  Flex,
  Box,
  Spacer,
  useToast,
  IconButton,
  Select,
  InputLeftAddon,
  InputGroup,
  Divider,
  Button,
  Skeleton
} from "@chakra-ui/react";
import Sidebar from "../sections/Sidebar/Sidebar";
// import RingLoader from "react-spinners/RingLoader";
import { differenceInDays } from "date-fns";

import { AiOutlineFileSearch } from "react-icons/ai";
// import DatePicker from "../common/date-picker/DatePicker";
//import { format,differenceInCalendarDays } from 'date-fns'
import statisticsService from "../../services/statistics.service";
import BarChart from "./barChart";
import "../Listing/style.css";
import "./statistics.css";
// import { setDate } from "date-fns";
import LabledDatePicker from "../common/LabeledDatePicker";
import BreadCrumbs from '../common/BreadCrumbs'
import Loader from '../common/Loader'; 
import Header from  '../sections/Header';

import countriesService from "../../services/countries.service";
import preferencesService from "../../services/preferences.service";

function Statistics() {
  const toast = useToast();
  const [isLoading, setisLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [country, setCountry] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [graphHeading,setGraphHeading] =useState({groupByMerchant:'',groupByDate:''});
  const [groupByMerchantData, setGroupByMerchantData] = useState({
    labels: [],
    data: [],
  });
  const [groupByDateData, setgroupByDateData] = useState({
    labels: [],
    data: [],
  });
  const [totalCase, setTotalCase] = useState(0);
  const [validationErrors, setValidationErrors] = useState({
    startDate: null,
    endDate: null,
  });

  //Processing the Api result
  const processResult = (result) => {
    setisLoading(false);
    if (result.error) {
      toast({
        title: result.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      return;
    }
    console.log('result ',result)
    setGroupByMerchantData({
      labels: result.groupByMerchant.graphData.labels,
      data: result.groupByMerchant.graphData.data,
    });
    setgroupByDateData({
      labels: result.groupByDate.graphData.labels,
      data: result.groupByDate.graphData.data,
    });
    setStartDate(new Date(result.groupByMerchant.startDate));
    setEndDate(new Date(result.groupByMerchant.endDate));
    setTotalCase(result.groupByMerchant.graphData.totalCase);
    setGraphHeading(prev=>{
      return {...prev,
        groupByMerchant:`Top 25 Number of cases for merchant for 
        ${new Date(result.groupByMerchant.endDate)>=new Date() ?'last ':''}
        ${differenceInDays(new Date(result.groupByMerchant.endDate),new Date(result.groupByMerchant.startDate))+1} days`,
        groupByDate:`Number of cases by date for 
        ${new Date(result.groupByMerchant.endDate)>=new Date() ? 'last ' :''}
        ${differenceInDays(new Date(result.groupByMerchant.endDate),new Date(result.groupByMerchant.startDate))+1} days`
      }
    })
  };

  //Inital fetching — load countries, pick the configured default, then fetch its stats.
  useEffect(() => {
    (async () => {
      setisLoading(true);
      // Prefer the user's own default country; fall back to the global default.
      const prefs = JSON.parse(localStorage.getItem("preferences") || "{}");
      let initial = prefs.defaultCountry || "";
      const res = await countriesService.getCountries();
      if (res && res.countries) {
        setCountryOptions(res.countries.map((c) => ({ code: c.code, name: c.name })));
        if (!initial) {
          const def = res.countries.find((c) => c.isDefault);
          if (def) initial = def.code;
        }
      }
      setCountry(initial);
      let data = await statisticsService.fetch({ country: initial }); // API call
      processResult(data);
      return;
    })();
    //Disabling the ES-lint dependency warning, This hook is to implement componentdidmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Fetching the result based on user input startdate and enddate
  const handleFetch = async () => {
    if (!startDate || !endDate) {
      let error = {};
      if (!startDate) error["startDate"] = "Start date required...!";
      if (!endDate) error["endDate"] = "End date required...!";
      setValidationErrors({ ...validationErrors, ...error });
      return;
    }
    if (startDate > endDate) {
      setEndDate(null);
      // setValidationErrors({...validationErrors,'endDate':"Please select the date greater than or equal start date"});
      return;
    }
    setisLoading(true);
    let data = await statisticsService.fetch({ startDate, endDate, country })
    processResult(data); // API call
  };
  const CountryChange = async (event) => { 
    setisLoading(true);
    let country = event.target.value;
    setCountry(prev=>country);
    let data = await statisticsService.fetch ({ country, startDate, endDate } );
    processResult(data);
  }
  // Save the currently selected country as this user's default (per-user preference).
  const setAsMyDefault = async () => {
    if (!country) return;
    await preferencesService.update({ defaultCountry: country });
    const prefs = JSON.parse(localStorage.getItem("preferences") || "{}");
    prefs.defaultCountry = country;
    localStorage.setItem("preferences", JSON.stringify(prefs));
    toast({ title: `Set ${country} as your default`, position: "top", status: "success", isClosable: true });
  };
  return (
    <Box>
      <Flex>
        <Sidebar />
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header>
            <Flex p={2}>
              <Box pr={2}>
                <LabledDatePicker
                  label="Start date"
                  validationClass={
                    validationErrors.startDate ? "inputValidationError" : ""
                  }
                  selected={startDate}
                  maxDate={new Date()}
                  onChange={(date) => {
                    if (startDate > endDate) setEndDate(null);
                    setValidationErrors({
                      ...validationErrors,
                      startDate: null,
                    });
                    setStartDate(date);
                  }}
                />
              </Box>
              <Box pr={2}>
                <LabledDatePicker
                  label="End date"
                  validationClass={
                    validationErrors.endDate ? "inputValidationError" : ""
                  }
                  selected={endDate}
                  minDate={startDate}
                  maxDate={new Date()}
                  onChange={(date) => {
                    setValidationErrors({
                      ...validationErrors,
                      endDate: null,
                    });
                    setEndDate(date);
                  }}
                />
              </Box>
              <Spacer />
              <Box pr={2}>
                <IconButton
                  size="md"
                  aria-label="Search"
                  borderWidth={'1px'}
                  borderColor={'rgb(94,94,114,.3)'}
                  onClick={handleFetch}
                  isLoading={isLoading}
                  icon={<AiOutlineFileSearch />}
                />
              </Box>
              <Spacer />
              <Divider pr={2} mt={-3} h="60px" orientation="vertical" />
              <Flex direction="column">
                <InputGroup>
                  <InputLeftAddon mr={-.5} fontSize=".8rem" children={'Country'} borderColor={'rgb(94,94,114,.3)'} />
                    <Select
                        pr={1}
                        fontSize=".8rem"
                        width='150px'
                        borderColor={validationErrors.action ? "red" : "#E2E8F0"}
                        style={{ borderRadius: "5px" }}
                        size="md"
                        onChange={CountryChange}
                        value={country}
                        >
                        {countryOptions.map((country, i) => {
                            return (
                            <option key={i} value={country.code} size="sm">
                                {country.name}
                            </option>
                            );
                        })}
                    </Select>
                </InputGroup>
                <Button mt={1} size="xs" variant="link" colorScheme="teal" onClick={setAsMyDefault} isDisabled={!country}>
                  ★ Set as my default
                </Button>
              </Flex>
            </Flex>
          </Header>
          <Box  pl="2" pb="2" >
            <BreadCrumbs />
          </Box>
          {/* <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)"  overflowX="scroll" h="90vh"> */}
          <Flex ml={3} mr={3} pt={2} borderWidth="1px" borderRadius="lg" overflowY="auto" h="87vh" flexDirection="column" >
            <Flex width='100%'>
              <Spacer />
              {isLoading ? (
                <Skeleton height="320px" width="42%" borderRadius="md" />
              ) : (
                <BarChart
                  heading={graphHeading.groupByMerchant}
                  data={groupByMerchantData}
                  total={totalCase}
                  lable={"# of case"}
                  color={"#4285f4"}
                  yAxesLabel={"# of case"}
                />
              )}
              <Spacer />
              {isLoading ? (
                <Skeleton height="320px" width="42%" borderRadius="md" />
              ) : (
                <BarChart
                  heading={graphHeading.groupByDate}
                  data={groupByDateData}
                  total={totalCase}
                  lable={"# of case"}
                  color={"#4285f4"}
                  yAxesLabel={"# of case"}
                />
              )}
              <Spacer />
            </Flex>
          </Flex>
          {/* </Grid> */}
        </Box>
      </Flex>
    </Box>
  );
}

export default Statistics;
